'use client';
import { TileList, TileListProps } from '../tileList/tileList';

export interface CasesProps extends TileListProps {
  itemsPerPage: number;
  _pageCount: number;
  currentPage: number;
}

export const Cases = ({
  tiles: initialTiles,
  maxPerRow = 2,
  _pageCount,
}: CasesProps) => {
  return <TileList tiles={initialTiles} maxPerRow={maxPerRow} />;
};
